export const MAINTENANCE_PACKAGE_DETAILS_POPULATE = [
    {
        path: 'createdBy',
        model: 'User',
        select: 'name',
    },
    {
        path: 'updatedBy',
        model: 'User',
        select: 'name',
    },
];
